import {
  GET_CC_ORDER_CHARGE_REQUEST,
  GET_CC_ORDER_CHARGE_SUCCESS,
  GET_CC_ORDER_CHARGE_ERROR
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

export const getCCOrdersCharge = (token, values) => (dispatch) => {
  let cleanedVal = (values.customer === undefined || values.customer === null) ? null : values.customer.includes("'") ? values.customer.replace(/'/g, "''") : values.customer;
  dispatch({ type: GET_CC_ORDER_CHARGE_REQUEST });
  const newData = {
    ship_header_no: values.ship_no === undefined || values.ship_no === "" ? null : values.ship_no,
    order_header_no: values.order_no === undefined || values.order_no === "" ? null : values.order_no,
    from_date: moment(values.from_date).format("MM-DD-YYYY"),
    to_date: moment(values.to_date).format("MM-DD-YYYY"),
    reference_no: values.po_no === undefined || values.po_no === "" ? null : values.po_no,
    customer: cleanedVal === undefined || cleanedVal === "" ? null : cleanedVal,
    sp_id: values.sale_person === "All" || values.sale_person === undefined ? null : values.sale_person,
    region_id: values.region === "All" || values.region === undefined ? null : values.region,
    gender_id: values.gender === "All" || values.gender === undefined ? null : values.gender,
    payment_term_id: values.terms === "All" || values.terms === undefined ? null : values.terms,
    is_approved : values.is_approved === "All" || values.is_approved === undefined ? null : values.is_approved,
    email_address: values.email === "All" || values.email === undefined ? null : values.email,
    phone_no: values.phone === "All" || values.phone === undefined ? null : values.phone,
  };

  return axios({
    method: "POST",
    url: `${BASEURL}getAll/CCOrderCharge`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: newData,
  })
    .then((response) => {
      return dispatch({
        type: GET_CC_ORDER_CHARGE_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_CC_ORDER_CHARGE_ERROR,
        payload: [],
      });
    });
};
